import { tv } from "@opensea/ui-kit"

export const marginVariants = tv({
  variants: {
    variant: {
      default: "mx-2",
      negative: "-mx-2",
    },
  },
  defaultVariants: {
    variant: "default",
  },
})
